import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';
import defaultTranslations from 'translations/index.mjs';
import ChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import _ from 'lodash';
import * as O from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';
import { getCookieTokens } from '@schemeserve/global-utils';

const defaultFallback = {
  type: 'backend',
  init: () => {},
  read: (language, namespace, callback) => {
    callback(null, defaultTranslations);
  },
};

const getCustomHeaders = () => {
  if (process.env.NODE_ENV === 'development') {
    if (window.apiKey) {
      return {
        'x-api-key': window.apiKey,
      };
    }
    const token = pipe(
      getCookieTokens(),
      O.map((tokens) => tokens.accessToken),
      O.getOrElse(() => ''),
    );
    return {
      authorization: `bearer ${token}`,
    };
  }
  return null;
};

export const translationsInit = async () =>
  new Promise((resolve) => {
    i18n
      .use(ChainedBackend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        fallbackLng: 'en-GB',
        load: 'currentOnly',
        debug: false,
        react: {
          useSuspense: false,
        },
        keySeparator: '.',
        interpolation: {
          escapeValue: false,
        },
        parseMissingKeyHandler: (key) => _.get(defaultTranslations, key),
        backend: {
          backends: [LocalStorageBackend, HttpApi, defaultFallback],
          backendOptions: [
            {
              prefix: 'i18next_res_',
              expirationTime: 1 * 24 * 60 * 60 * 1000, // 1 days
            },
            {
              allowMultiLoading: true,
              loadPath: `${window.ENVIRONMENT.ApiRoot.Base}/translations/{{lng}}`,
              crossDomain: true,
              customHeaders: getCustomHeaders(),
            },
          ],
        },
      })
      .then(() => resolve());
  });

export default i18n;
